import { memo } from "react";
import { Chat } from "src/lib";
import { normalizeMarkdownTable } from "src/lib/components/composition/Chat/utils/normalizeMarkdownTable";

export type ChatMessageItem = {
    id: string;
    text: string;
    timestamp: Date;
    context?: string;
    answer?: boolean;
    status?: "loading" | "streaming" | "error" | "done";
    streamStatus?: string;
    jsonMessage?: any;
    questionText?: string;
    attachments?: { filename: string; mime_type?: string; sizeBytes?: number }[];
};

type ChatMessageRowProps = {
    message: ChatMessageItem;
    streamingMinHeight?: number;
};

export const ChatMessageRow = memo(
    function ChatMessageRow({ message, streamingMinHeight }: ChatMessageRowProps) {
        const displayText =
            message.status === "streaming" ? message.text : normalizeMarkdownTable(message.text);

        const isStreamingAssistant =
            message.answer &&
            message.status === "streaming" &&
            streamingMinHeight != null;

        return (
            <div
                data-chat-message-id={message.id}
                style={
                    isStreamingAssistant
                        ? { minHeight: streamingMinHeight, boxSizing: "border-box" }
                        : undefined
                }
            >
                <Chat.Message
                    text={displayText}
                    context={message.context}
                    answer={message.answer}
                    status={message.status}
                    streamStatus={message.streamStatus}
                    timestamp={message.timestamp?.toLocaleDateString("pt-BR")}
                    jsonMessage={message.jsonMessage}
                    questionText={message.questionText}
                    attachments={message.attachments}
                />
            </div>
        );
    },
    (prev, next) =>
        prev.message.id === next.message.id &&
        prev.message.text === next.message.text &&
        prev.message.status === next.message.status &&
        prev.message.streamStatus === next.message.streamStatus &&
        prev.message.context === next.message.context &&
        prev.message.answer === next.message.answer &&
        prev.streamingMinHeight === next.streamingMinHeight
);
